module.exports = "pegasus/assets/blocks/column-1-tech.png";